import { css } from '@emotion/react';
import React from 'react';

import { KAI_SHIKI_LAYOUT, styleguideColors, styleguideFontSize, styleguideFontWeight } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { styleguideFontFamily } from '@kaiizen/kai-shiki/core';
import { Button, ButtonColorStyle } from './Button';

const LABELED_CARD_STYLE = css`
  label: LABELED_CARD_STYLE;
  background: ${styleguideColors.white};
  border: 1px solid ${styleguideColors.stroke};
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
`;

const CLICKABLE_LABELED_CARD_STYLE = css`
  label: CLICKABLE_LABELED_CARD_STYLE;
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

const TITLE_CONTAINER_STYLE = css`
  label: TITLE_CONTAINER_STYLE;
  padding: 0 ${KAI_SHIKI_LAYOUT.spacing2}px;
  border-bottom: 1px solid ${styleguideColors.stroke};
  display: flex;
  min-height: ${KAI_SHIKI_LAYOUT.spacing6}px;
  justify-content: space-between;
  align-items: center;
  gap: ${KAI_SHIKI_LAYOUT.spacing2}px;
`;

const CARD_TITLE_STYLE = css`
  label: CARD_TITLE_STYLE;
  font-family: ${styleguideFontFamily.display};
  font-size: ${pxToRem(styleguideFontSize.displayModalTitle)};
  font-weight: ${styleguideFontWeight.bold};
  color: ${styleguideColors.ink};
`;

const CONTENT_STYLE = css`
  label: CONTENT_STYLE;
  padding: ${KAI_SHIKI_LAYOUT.spacing2}px;
  flex: 1;
  min-height: 0;
`;

const BUTTONS_CONTAINER_STYLE = css`
  label: BUTTONS_CONTAINER_STYLE;
  display: flex;
  min-width: 0;
  gap: ${KAI_SHIKI_LAYOUT.spacing1}px;
`;

export const LabeledCard = ({ title, children, titleRight, buttonLabel, onButtonClick, buttons, height, onClick }: {
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  titleRight?: React.ReactNode;
  buttonLabel?: string; // @deprecated use buttons instead
  onButtonClick?: () => void;
  buttons?: ({ disabled?: boolean; label: string; onClick: () => void; buttonStyle?: ButtonColorStyle } | undefined | false)[];
  height?: string | number;
  onClick?: () => void;
}) => (
  <div css={[LABELED_CARD_STYLE, onClick && CLICKABLE_LABELED_CARD_STYLE, css`height: ${height}`]} onClick={onClick}>
    <div css={TITLE_CONTAINER_STYLE}>
      {typeof title === 'string' ? <div css={CARD_TITLE_STYLE}>{title}</div> : title}
      {titleRight}
      <div css={BUTTONS_CONTAINER_STYLE}>
        {buttonLabel && onButtonClick && <Button key={buttonLabel} size='small' buttonStyle='white' onClick={onButtonClick}>{buttonLabel}</Button>}
        {buttons?.filter(a => !!a).map(({ label, onClick, buttonStyle, disabled }) => (
          <Button key={label} size='small' buttonStyle={buttonStyle || 'white'} onClick={onClick} disabled={disabled}>{label}</Button>
        ))}
      </div>
    </div>
    <div css={CONTENT_STYLE}>{children}</div>
  </div>
);
